// This file is automatically generated. Do not edit manually.

import { InvoicePaymentEvent } from "src/api/generated/erp/accountingIntegration/model/invoicePaymentEvent";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace InvoicePaymentEventsApi {
	export async function getInvoicePaymentEvents(args: { invoiceId: number }): Promise<Array<InvoicePaymentEvent>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/paymentEvents/getInvoicePaymentEvents",
			method: "POST",
			data: {
				invoiceId: args.invoiceId,
			},
		});
		return response as Array<InvoicePaymentEvent>;
	}
}
